/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1TradeConfirmationsTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_EVENT_ENTITY_NAME = 'ixc.generate.v1.TradeConfirmationsTaskEvent';
export const ixcGenerateV1TradeConfirmationsTaskEventEntity = new schema.Entity<IxcGenerateV1TradeConfirmationsTaskEvent>(IXC_GENERATE_V1_TRADE_CONFIRMATIONS_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcGenerateV1TradeConfirmationsTaskEvent) => `${entity.metadata?.eventId}` });

